import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-invoice-detail-modal',
  templateUrl: './invoice-detail-modal.component.html',
  styleUrls: ['./invoice-detail-modal.component.css']
})
export class InvoiceDetailModalComponent {

  @Input() invoiceDetail:any;
  @Output() closeModal = new EventEmitter<any>();


  constructor(){}

  ngOnInit(): void {
    console.log('invoiceDetail', this.invoiceDetail);
  }

  onCloseModal(){
    this.closeModal.emit();
  }
  
}
